__turbopack_context__.v({
  "chatAnswer": "WGpxCa_chatAnswer",
  "chatAnswerContainer": "WGpxCa_chatAnswerContainer",
});
